import styled from 'styled-components';

const Card = styled.div`
  width: 100%;
  height: 280px;
  padding: 28px 24px 24px;
  border-radius: 16px;
  background: var(--white);
`;

export default Card;
